<template>
  <div class="partner-widget" v-if="partnersOffers != null && partnersOffers.length > 0" ref="container">
    <div class="partner-widget__wrapper" :class="sizeSuffix">
      <!--      <div class="partner-widget__title">Наши партнеры</div>-->
      <div class="partner-widget__partners">
        <VueSlickCarousel v-bind="settingsSlide">
          <a class="partner-widget__item" :href="linkWithSysSubs(item.urls, 'partners')" v-for="item in partnersOffers"
             :key="item.id" target="_blank">
            <img :src="item.logo">
          </a>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import WidgetMarketSettingsClass from './../common/WidgetMarketSettingsClass.js';
import {mapActions, mapGetters, mapState} from "vuex";
import links from "@/common/links";

export default {
  name: 'Partners',
  mixins: [links],
  components: {
    VueSlickCarousel
  },
  props: {
    options: {default: null},
  },
  data() {
    return {
      category: [14],
      settingsSlide: {
        autoplay: true,
        arrows: false,
        dots: false,
        slidesToShow: 5,
        infinite: true,
        swipe: false,
      },
      sizeSuffix: '',
    };
  },
  watch: {
    offers() {
      if (window.WidgetMarketSettings !== undefined) {
        window.WidgetMarketSettings.dispatchEvent(new Event('onAfterLoadOffers'));
      }
    }
  },
  computed: {
    ...mapGetters([
      'partnersOffers',
    ]),
    ...mapState([
      'platformId',
      'offers'
    ]),
    baseUrl() {
      return process.env.VUE_APP_WIDGET_MARKET_URL;
    },

  },
  methods: {
    onChange(event) {
      this.font = event.options.font ?? this.font;

      if (this.category != event.options.category) {
        this.category = event.options.category ?? this.category;

        if (window.WidgetMarketSettings !== undefined) {
          window.WidgetMarketSettings.dispatchEvent(new Event('onBeforeLoadOffers'));
        }

        this.loadOffers({
          categoryIds: this.category,
          platformId: this.platformId
        });
      }
    },
    resize() {
      const width = this.$el.offsetWidth;
      if (width < 370) {
        this.sizeSuffix = 'mobile';
        this.settingsSlide.slidesToShow = 1;
      } else if (width >= 370 && width < 900) {
        this.sizeSuffix = 'tablet';
        this.settingsSlide.slidesToShow = 2;
      } else if (width >= 900 && width < 1100) {
        this.sizeSuffix = 'desktop';
        this.settingsSlide.slidesToShow = 3;
      } else {
        this.sizeSuffix = 'desktop';
        this.settingsSlide.slidesToShow = 4;
      }
    },
    ...mapActions([
      'loadOffers',
      'initLoadOffers'
    ]),
  },
  updated() {
    if (window.WidgetMarketSettings !== undefined) {
      let evt = new Event('resize');
      evt.resize_info = {
        height: this.$refs.container.clientHeight
      };
      window.WidgetMarketSettings.dispatchEvent(evt);
    }
  },
  mounted() {
    if (this.options !== null) {
      this.font = this.options.font ?? 'Roboto';
      this.category = this.options.category ?? this.category;
    }

    // global runtime-sync object
    if (window.WidgetMarketSettings === undefined) {
      window.WidgetMarketSettings = new WidgetMarketSettingsClass();
    }
    window.WidgetMarketSettings.addEventListener('change', this.onChange);
    window.addEventListener('resize', () => this.resize());

    window.WidgetMarketSettings.dispatchEvent(new Event('onBeforeLoadOffers'));
    this.initLoadOffers(this.options);

    this.resize();
  },
  unmounted() {
    if (window.WidgetMarketSettings !== undefined) {
      window.WidgetMarketSettings.removeEventListener('change', this.onChange);
    }
  }
}
</script>
